import styled from 'styled-components';

import AnnouncementForm from './AnnoucementForm';

function AnnouncementsPage() {
  return (<AnnouncementsContainer>
    <AnnouncementForm />
  </AnnouncementsContainer>);
}

export default AnnouncementsPage;

const AnnouncementsContainer = styled.div`
  margin: 16px 0;
  background-color: #FFFFFF;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
  padding: 2rem;
`;
